import React, { useState, useEffect } from 'react';
import { trackContactWidget, trackWhatsAppClick, trackPhoneClick } from '../utils/analytics';

const FloatingContactWidget = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Manage body scroll on mobile when widget is expanded
  useEffect(() => {
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      if (isExpanded) {
        document.body.classList.add('widget-open');
      } else {
        document.body.classList.remove('widget-open');
      }
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('widget-open');
    };
  }, [isExpanded]);

  const toggleWidget = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    trackContactWidget(newState ? 'open' : 'close');
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleWidget();
    }
    if (event.key === 'Escape' && isExpanded) {
      setIsExpanded(false);
    }
  };

  // Close widget on window resize if on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isExpanded) {
        setIsExpanded(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isExpanded]);

  return (
    <>
      {/* Floating Contact Widget */}
      <div className={`floating-contact-widget ${isExpanded ? 'expanded' : ''}`}>
        <div 
          className="widget-toggle" 
          onClick={toggleWidget}
          onKeyDown={handleKeyPress}
          tabIndex={0}
          role="button"
          aria-label={isExpanded ? "Close contact widget" : "Open contact widget"}
          aria-expanded={isExpanded}
        >
          <span className="widget-icon" aria-hidden="true">
            {isExpanded ? '✕' : '📞'}
          </span>
          {!isExpanded && <span className="widget-text">Contact</span>}
        </div>
        
        {isExpanded && (
          <div className="widget-content" role="dialog" aria-label="Contact information">
            <div className="widget-header">
              <h3>Contact Grand Beach Villa</h3>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon" aria-hidden="true">📍</span>
                <div className="contact-details">
                  <strong>Address</strong>
                  <p>Payyambalam Beach Road, Po, Chalad, Kannur, Kerala 670014, India</p>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon" aria-hidden="true">📞</span>
                <div className="contact-details">
                  <strong>Phone</strong>
                  <a 
                    href="tel:+919895162332" 
                    aria-label="Call +91 98951 62332"
                    onClick={() => trackPhoneClick('widget')}
                  >
                    +91 98951 62332
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon" aria-hidden="true">📱</span>
                <div className="contact-details">
                  <strong>WhatsApp</strong>
                  <a 
                    href="https://api.whatsapp.com/send/?phone=919895162332&text=Hello+Grand+Beach+Villa%2C+I+want+to+book+my+room." 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="whatsapp-link"
                    aria-label="Send WhatsApp message to Grand Beach Villa"
                    onClick={(e) => {
                      e.preventDefault();
                      trackWhatsAppClick('widget');
                      if (window.gtag_report_conversion) {
                        window.gtag_report_conversion('https://api.whatsapp.com/send/?phone=919895162332&text=Hello+Grand+Beach+Villa%2C+I+want+to+book+my+room.');
                      }
                      window.open('https://api.whatsapp.com/send/?phone=919895162332&text=Hello+Grand+Beach+Villa%2C+I+want+to+book+my+room.', '_blank');
                    }}
                  >
                    Message us on WhatsApp
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon" aria-hidden="true">✉️</span>
                <div className="contact-details">
                  <strong>Email</strong>
                  <a href="mailto:grandbeachvilla@gmail.com" aria-label="Send email to Grand Beach Villa">grandbeachvilla@gmail.com</a>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon" aria-hidden="true">🕐</span>
                <div className="contact-details">
                  <strong>Check-in/out</strong>
                  <p>Check-in: 2:00 PM | Check-out: 11:00 AM</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Backdrop for mobile */}
      {isExpanded && (
        <div 
          className="widget-backdrop" 
          onClick={toggleWidget}
          aria-hidden="true"
        ></div>
      )}
    </>
  );
};

export default FloatingContactWidget;
